/* Pass the TSIA2 Math, Shopify build. Generated by build_shopify.py, do not hand edit. */
window.TSIA2PracticeApp = function (hostEl) {
  var __doc = window.document;
  var root = hostEl.shadowRoot || hostEl.attachShadow({ mode: 'open' });
  root.innerHTML = "<style>*{box-sizing:border-box}\n:host{\n  --ink:#4A3352; --soft:#7A6485; --rule:#E7DCEE; --fill:#FDF7FC; --bg:#FFF9FC;\n  --blush:#FFB3C9; --blushi:#E2739A; --peach:#FFC9A6; --peachi:#DE8B54;\n  --butter:#FBDF9E; --butteri:#D6A83C; --mint:#C7E9B0; --minti:#6FA95A;\n  --seafoam:#A7E3D9; --seafoami:#4FA598; --sky:#A9D5F2; --skyi:#4E93C9;\n  --peri:#C1BEF2; --perii:#6E68C6; --lilac:#DAB9EE; --lilaci:#9257BD;\n  --gum:#F6B9DF; --gumi:#C75FA1;\n  --band:var(--lilac); --sink:var(--lilaci);\n}\n:host{display:block;background:var(--bg);color:var(--ink);font-family:'Quicksand',system-ui,sans-serif;font-size:16px;line-height:1.5;-webkit-font-smoothing:antialiased}\nh1,h2,h3,h4,.f{font-family:'Fredoka',system-ui,sans-serif;font-weight:600}\n.motto{font-family:'Caveat',cursive;font-weight:600}\nsup{font-size:.68em}\nbutton{font-family:inherit;font-size:inherit;color:inherit;cursor:pointer}\n.wrap{max-width:900px;margin:0 auto;padding:0 16px}\n\n/* top */\n.top{background:#fff;border-bottom:1px solid var(--rule);position:relative;z-index:1}\n.topin{max-width:900px;margin:0 auto;padding:12px 16px;display:flex;align-items:center;gap:12px;\n       flex-wrap:wrap}\n.brand{display:flex;flex-direction:column;line-height:1.1}\n.brand .k{font-family:'Fredoka';font-size:10px;letter-spacing:2.4px;color:var(--gumi)}\n.brand .t{font-family:'Fredoka';font-size:21px;font-weight:700}\n.spacer{flex:1}\n.tabs{display:flex;gap:6px;flex-wrap:wrap;width:100%}\n.tab{border:1.5px solid var(--rule);background:#fff;border-radius:99px;padding:6px 14px;\n     font-weight:600;font-size:14px;color:var(--soft)}\n.tab[aria-selected=\"true\"]{background:var(--band);border-color:var(--band);color:var(--ink)}\n.tab .pill{background:#fff;border-radius:99px;padding:0 7px;margin-left:6px;font-size:12px}\n\nmain{padding:20px 0 60px}\n.view{display:none}\n.view.on{display:block}\n\n.card{background:#fff;border:1.6px solid var(--band);border-radius:18px;padding:18px 20px;\n      margin:0 0 16px}\n.card h2{margin:0 0 4px;font-size:20px;color:var(--sink)}\n.card h3{margin:0 0 6px;font-size:16px;color:var(--sink)}\n.lede{color:var(--soft);font-size:14.5px;margin:0 0 14px}\n\n.chips{display:flex;gap:8px;flex-wrap:wrap;margin-bottom:16px}\n.chip{border:1.6px solid var(--rule);background:#fff;border-radius:99px;padding:8px 16px;\n      font-weight:600;font-size:14px;display:flex;align-items:center;gap:8px}\n.chip i{width:11px;height:11px;border-radius:4px;display:block}\n.chip[aria-pressed=\"true\"]{border-color:var(--sink);background:var(--fill)}\n.chip small{color:var(--soft);font-weight:600}\n\n.qhead{display:flex;align-items:center;gap:10px;margin-bottom:10px;flex-wrap:wrap}\n.qnum{background:var(--band);color:var(--ink);border-radius:99px;padding:3px 12px;\n      font-family:'Fredoka';font-size:13px}\n.qskill{font-size:12px;color:var(--soft)}\n.calcchip{border:1px solid var(--band);color:var(--sink);border-radius:99px;font-size:11px;\n          padding:1px 9px;font-weight:600}\n.stem{font-size:17px;margin-bottom:12px}\n.figbox{margin:6px 0 12px;overflow-x:auto}\n.figbox svg{max-width:100%;height:auto}\n.dtab{border-collapse:collapse;font-size:14px}\n.dtab th,.dtab td{border:1px solid var(--rule);padding:5px 12px;text-align:center}\n.dtab th{background:var(--fill);font-family:'Fredoka';font-weight:600}\n\n.opts{display:grid;gap:9px;margin:0 0 4px;padding:0;list-style:none}\n.opt{display:flex;align-items:flex-start;gap:10px;width:100%;text-align:left;\n     border:1.6px solid var(--rule);background:#fff;border-radius:13px;padding:11px 14px;\n     transition:border-color .12s, background .12s}\n.opt:hover:not([disabled]){border-color:var(--band);background:var(--fill)}\n.opt .L{font-family:'Fredoka';font-weight:600;color:var(--sink);min-width:17px}\n.opt[data-state=\"right\"]{border-color:#6FA95A;background:#F1F9EC}\n.opt[data-state=\"wrong\"]{border-color:#E2739A;background:#FFF1F6}\n.opt[data-state=\"miss\"]{border-color:#6FA95A;border-style:dashed}\n.opt[disabled]{cursor:default}\n\n.verdict{display:flex;align-items:center;gap:9px;margin:12px 0 8px;font-family:'Fredoka';\n         font-size:15px}\n.verdict.ok{color:#5E9349}\n.verdict.no{color:#C75FA1}\n.steps{background:var(--fill);border:1px solid var(--rule);border-radius:13px;padding:12px 15px;\n       font-size:15px}\n.steps div{margin:2px 0}\n.steps .lab{font-family:'Fredoka';font-size:12px;letter-spacing:1px;color:var(--soft);\n            margin-bottom:4px}\n\n.row{display:flex;gap:10px;flex-wrap:wrap;align-items:center;margin-top:14px}\n.btn{border:0;background:var(--sink);color:#fff;border-radius:99px;padding:10px 22px;\n     font-weight:600;font-family:'Fredoka'}\n.btn.ghost{background:#fff;color:var(--sink);border:1.6px solid var(--band)}\n.btn.small{padding:7px 15px;font-size:14px}\n.btn[disabled]{opacity:.45;cursor:default}\n\n.meter{height:9px;border-radius:99px;background:var(--rule);overflow:hidden;margin:6px 0}\n.meter i{display:block;height:100%;background:var(--band);border-radius:99px}\n.stat{display:flex;justify-content:space-between;font-size:14px;margin-top:10px}\n.stat b{font-family:'Fredoka'}\n\n.grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(42px,1fr));gap:7px;margin:12px 0}\n.gq{border:1.5px solid var(--rule);background:#fff;border-radius:10px;padding:7px 0;\n    font-family:'Fredoka';font-size:13px;text-align:center}\n.gq[data-done=\"1\"]{background:var(--band);border-color:var(--band)}\n.gq[aria-current=\"true\"]{outline:2.5px solid var(--sink);outline-offset:1px}\n.gq[data-right=\"1\"]{background:#DFF0D4;border-color:#9DCB86}\n.gq[data-right=\"0\"]{background:#FFE2EC;border-color:#F4A5C0}\n\n.tiles{display:grid;grid-template-columns:repeat(auto-fit,minmax(200px,1fr));gap:12px}\n.tile{border:1.6px solid var(--band);background:#fff;border-radius:16px;padding:14px 16px;\n      text-align:left}\n.tile b{display:block;font-family:'Fredoka';font-size:17px;color:var(--sink)}\n.tile span{font-size:13px;color:var(--soft)}\n.tile .n{font-family:'Fredoka';font-size:26px;color:var(--sink)}\n\n.acc{border:1.6px solid var(--band);border-radius:14px;margin-bottom:10px;background:#fff;\n     overflow:hidden}\n.acc>button{width:100%;text-align:left;border:0;background:var(--fill);padding:11px 16px;\n            font-family:'Fredoka';font-weight:600;color:var(--sink);display:flex;\n            justify-content:space-between;align-items:center}\n.acc .body{padding:12px 16px;display:none;font-size:15px}\n.acc.open .body{display:block}\n.acc ul{margin:0;padding-left:18px}\n.acc li{margin:3px 0}\n.lrule{background:var(--fill);border:1px solid var(--rule);border-radius:11px;padding:9px 13px;\n       margin:8px 0;font-size:14.6px}\n.lrule .lab{font-family:'Fredoka';font-size:12px;letter-spacing:1px;color:var(--soft)}\n\n.report h3{margin:16px 0 6px}\n.barrow{display:flex;align-items:center;gap:10px;margin:7px 0;font-size:14px}\n.barrow .nm{width:120px;flex:0 0 auto}\n.barrow .bar{flex:1;height:14px;border-radius:99px;background:var(--rule);overflow:hidden}\n.barrow .bar i{display:block;height:100%;border-radius:99px}\n.barrow .vv{width:56px;text-align:right;font-family:'Fredoka';font-size:13px}\n\n.verd{border-radius:14px;padding:14px 18px;margin:12px 0;border:1.6px solid var(--band);\n      background:var(--fill)}\n.verd b{font-family:'Fredoka';font-size:18px;display:block;color:var(--sink)}\n\n.empty{color:var(--soft);font-size:15px;padding:10px 0}\n.foot{text-align:center;color:var(--soft);font-size:13px;padding:24px 0 8px}\n.foot a{color:var(--gumi)}\n\n@media (max-width:560px){\n  .brand .t{font-size:18px}\n  .stem{font-size:16px}\n  .card{padding:15px 15px}\n  .barrow .nm{width:86px;font-size:12.5px}\n}\n\n/* Shopify only */\n.wrap{max-width:var(--cc-max,900px)}\n.topin{max-width:var(--cc-max,900px)}\n@media (max-width:430px){.tabs{gap:5px}.tab{padding:6px 11px;font-size:13px}}\n</style><header class=\"top\"><div class=\"topin\">\n  <div class=\"brand\"><span class=\"k\">CUTE CALCULUS</span><span class=\"t\">Pass the TSIA2 Math</span></div>\n  <div class=\"spacer\"></div>\n  <div class=\"tabs\" id=\"tabs\" role=\"tablist\"></div>\n</div></header>\n<main><div class=\"wrap\">\n  <section id=\"v-practice\" class=\"view on\"></section>\n  <section id=\"v-tests\" class=\"view\"></section>\n  <section id=\"v-study\" class=\"view\"></section>\n  <section id=\"v-fix\" class=\"view\"></section>\n  <section id=\"v-progress\" class=\"view\"></section>\n  <div class=\"foot\">236 practice questions, every one worked out step by step.<br>\n  More free math at cutecalculus.com</div>\n</div></main>";
  window.TSIA2_SCROLL = function () {
    try { hostEl.scrollIntoView({ block: 'start' }); } catch (e) { window.scrollTo(0, 0); }
  };
  var document = {
    getElementById: function (id) { return root.getElementById(id); },
    querySelector: function (s) { return root.querySelector(s); },
    querySelectorAll: function (s) { return root.querySelectorAll(s); },
    createElement: function (t) { return __doc.createElement(t); },
    createElementNS: function (ns, t) { return __doc.createElementNS(ns, t); },
    createTextNode: function (t) { return __doc.createTextNode(t); },
    documentElement: hostEl,
    body: hostEl,
    fonts: __doc.fonts
  };
/* Pass the TSIA2 Math - practice page. Plain DOM, no framework. */
(function () {
  'use strict';
  var D = window.TSIA2_DATA;
  var L = window.TSIA2_LESSONS;
  var AREAS = ['QR', 'AR', 'GS', 'PS'];
  var LETTERS = ['A', 'B', 'C', 'D'];
  var scrollTop = window.TSIA2_SCROLL || function () { window.scrollTo(0, 0); };
  var KEY = 'tsia2-practice-v1';
  var TESTS = [
    { id: 'pretest', name: 'Warm Up Test', n: 20, blurb: 'Same mix as the real CRC test' },
    { id: 'testA', name: 'Practice Test A', n: 20, blurb: 'Full length, CRC blueprint' },
    { id: 'testB', name: 'Practice Test B', n: 20, blurb: 'Full length, CRC blueprint' },
    { id: 'deep', name: 'Deep Practice Test', n: 48, blurb: '12 from each area, like the Diagnostic' }
  ];

  // ---------------------------------------------------------------- state
  var S = { seen: {}, tests: {}, tone: {} };
  try {
    var raw = localStorage.getItem(KEY);
    if (raw) S = Object.assign(S, JSON.parse(raw));
  } catch (e) { /* private window, carry on */ }
  function save() {
    try { localStorage.setItem(KEY, JSON.stringify(S)); } catch (e) { /* fine */ }
  }

  // ---------------------------------------------------------------- data
  function deck(key) {
    if (key === 'pretest' || key === 'testA' || key === 'testB' || key === 'deep') {
      return D[key].items;
    }
    return D.sets[key];
  }
  function qid(key, i) { return key + ':' + i; }
  function getQ(id) {
    var p = id.split(':');
    return deck(p[0])[+p[1]];
  }
  function areaOf(id) { return getQ(id).area; }

  function allPracticeIds() {
    var out = [];
    AREAS.forEach(function (a) {
      deck(a).forEach(function (_, i) { out.push(qid(a, i)); });
    });
    return out;
  }
  function fixIds() {
    return Object.keys(S.seen).filter(function (id) { return S.seen[id].r === 0; });
  }
  function areaStats(a) {
    var ids = deck(a).map(function (_, i) { return qid(a, i); });
    var done = 0, right = 0;
    ids.forEach(function (id) {
      var s = S.seen[id];
      if (s) { done++; if (s.r) right++; }
    });
    return { done: done, right: right, total: ids.length };
  }

  // ---------------------------------------------------------------- utils
  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }
  function tint(node, area) {
    var m = D.meta[area];
    if (!m) return node;
    node.style.setProperty('--band', m.band);
    node.style.setProperty('--sink', m.ink);
    return node;
  }
  function pct(a, b) { return b ? Math.round((a / b) * 100) : 0; }
  function shuffleSeed(arr) { return arr; }

  // ---------------------------------------------------------------- shell
  var VIEWS = ['practice', 'tests', 'study', 'fix', 'progress'];
  var tabWrap = document.getElementById('tabs');
  var LABELS = { practice: 'Practice', tests: 'Full tests', study: 'Study', fix: 'Fix list',
                 progress: 'Progress' };

  function drawTabs() {
    tabWrap.innerHTML = '';
    VIEWS.forEach(function (v) {
      var b = el('button', 'tab', LABELS[v]);
      b.setAttribute('role', 'tab');
      b.setAttribute('aria-selected', v === current ? 'true' : 'false');
      if (v === 'fix') {
        var n = fixIds().length;
        if (n) b.innerHTML = LABELS[v] + '<span class="pill">' + n + '</span>';
      }
      b.onclick = function () { go(v); };
      tabWrap.appendChild(b);
    });
  }
  var current = 'practice';
  function go(v) {
    current = v;
    VIEWS.forEach(function (x) {
      document.getElementById('v-' + x).classList.toggle('on', x === v);
    });
    drawTabs();
    if (v === 'practice') drawPractice();
    if (v === 'tests') drawTests();
    if (v === 'study') drawStudy();
    if (v === 'fix') drawFix();
    if (v === 'progress') drawProgress();
    scrollTop();
  }

  // ---------------------------------------------------------------- question card
  function questionCard(id, opts) {
    // opts: {mode:'practice'|'test', answered:index|null, onAnswer, showSteps, label}
    var q = getQ(id);
    var card = tint(el('div', 'card'), q.area);
    var head = el('div', 'qhead');
    head.appendChild(el('span', 'qnum', opts.label || ('Question ' + q.n)));
    head.appendChild(el('span', 'qskill', D.meta[q.area].short + ' · ' + q.skill));
    if (q.calc === 'graph') head.appendChild(el('span', 'calcchip', 'calculator ok'));
    card.appendChild(head);
    card.appendChild(el('div', 'stem', q.stem));
    if (q.fig) card.appendChild(el('div', 'figbox', q.fig));

    var list = el('ul', 'opts');
    var buttons = [];
    q.opts.forEach(function (text, i) {
      var li = el('li');
      var b = el('button', 'opt');
      b.innerHTML = '<span class="L">' + LETTERS[i] + '</span><span>' + text + '</span>';
      b.onclick = function () { pick(i); };
      buttons.push(b);
      li.appendChild(b);
      list.appendChild(li);
    });
    card.appendChild(list);
    var after = el('div');
    card.appendChild(after);

    function paint(chosen, reveal) {
      buttons.forEach(function (b, i) {
        b.removeAttribute('data-state');
        if (chosen == null) return;
        if (reveal) {
          if (i === q.ans) b.setAttribute('data-state', i === chosen ? 'right' : 'miss');
          else if (i === chosen) b.setAttribute('data-state', 'wrong');
        } else if (i === chosen) {
          b.setAttribute('data-state', 'miss');
        }
      });
    }

    function pick(i) {
      if (opts.mode === 'test') {
        opts.onAnswer(i);
        paint(i, false);
        return;
      }
      buttons.forEach(function (b) { b.disabled = true; });
      var ok = i === q.ans;
      paint(i, true);
      after.innerHTML = '';
      var v = el('div', 'verdict ' + (ok ? 'ok' : 'no'),
        ok ? '✦ Correct' : '✦ Not this time. The answer is ' + LETTERS[q.ans] + '.');
      after.appendChild(v);
      var st = el('div', 'steps');
      st.appendChild(el('div', 'lab', 'HOW TO GET THERE'));
      q.steps.forEach(function (s) { st.appendChild(el('div', null, s)); });
      after.appendChild(st);
      opts.onAnswer(i, ok, after);
    }

    if (opts.answered != null) {
      if (opts.mode === 'test' && !opts.showSteps) paint(opts.answered, false);
      else paint(opts.answered, true);
    }
    if (opts.showSteps) {
      buttons.forEach(function (b) { b.disabled = true; });
      var st2 = el('div', 'steps');
      st2.appendChild(el('div', 'lab', 'HOW TO GET THERE'));
      q.steps.forEach(function (s) { st2.appendChild(el('div', null, s)); });
      after.appendChild(st2);
    }
    return { node: card, after: after };
  }

  // ---------------------------------------------------------------- practice
  var pArea = null;
  var pQueue = [];
  var pIndex = 0;
  var vPractice = document.getElementById('v-practice');

  function buildQueue(a) {
    var ids = deck(a).map(function (_, i) { return qid(a, i); });
    var fresh = ids.filter(function (id) { return !S.seen[id]; });
    var wrong = ids.filter(function (id) { return S.seen[id] && !S.seen[id].r; });
    var done = ids.filter(function (id) { return S.seen[id] && S.seen[id].r; });
    return fresh.concat(wrong, done);
  }

  function drawPractice() {
    vPractice.innerHTML = '';
    var intro = el('div');
    intro.appendChild(el('h2', 'f', 'Practice by content area'));
    intro.appendChild(el('p', 'lede',
      'Pick an area. You get the answer and the full steps the moment you choose. ' +
      'Anything you miss lands in your fix list.'));
    vPractice.appendChild(intro);

    var chips = el('div', 'chips');
    AREAS.forEach(function (a) {
      var st = areaStats(a);
      var c = tint(el('button', 'chip'), a);
      c.setAttribute('aria-pressed', a === pArea ? 'true' : 'false');
      c.innerHTML = '<i style="background:' + D.meta[a].band + '"></i>' +
        D.meta[a].short + ' <small>' + st.done + '/' + st.total + '</small>';
      c.onclick = function () {
        pArea = a; pQueue = buildQueue(a); pIndex = 0; drawPractice();
      };
      chips.appendChild(c);
    });
    vPractice.appendChild(chips);

    if (!pArea) {
      var t = el('div', 'tiles');
      AREAS.forEach(function (a) {
        var st = areaStats(a);
        var tile = tint(el('button', 'tile'), a);
        tile.innerHTML = '<b>' + D.meta[a].name + '</b>' +
          '<span>' + st.total + ' questions · ' + D.meta[a].crc +
          ' of the 20 on the real CRC test</span>' +
          '<div class="meter"><i style="width:' + pct(st.done, st.total) +
          '%;background:' + D.meta[a].ink + '"></i></div>' +
          '<span>' + st.right + ' right of ' + st.done + ' tried</span>';
        tile.onclick = function () { pArea = a; pQueue = buildQueue(a); pIndex = 0; drawPractice(); };
        t.appendChild(tile);
      });
      vPractice.appendChild(t);
      return;
    }

    var st = areaStats(pArea);
    var bar = tint(el('div', 'card'), pArea);
    bar.innerHTML = '<h3>' + D.meta[pArea].name + '</h3>' +
      '<div class="meter"><i style="width:' + pct(st.done, st.total) +
      '%;background:' + D.meta[pArea].ink + '"></i></div>' +
      '<div class="stat"><span>' + st.done + ' of ' + st.total + ' tried</span><span>' +
      (st.done ? '<b>' + pct(st.right, st.done) + '%</b> right' : 'not started yet') +
      '</span></div>';
    vPractice.appendChild(bar);

    if (pIndex >= pQueue.length) {
      var done = tint(el('div', 'card'), pArea);
      done.innerHTML = '<h3>That is the whole set</h3>' +
        '<p class="lede">You worked all ' + st.total + ' questions in this area.</p>';
      var again = el('button', 'btn', 'Start over');
      again.onclick = function () { pQueue = buildQueue(pArea); pIndex = 0; drawPractice(); };
      done.appendChild(again);
      vPractice.appendChild(done);
      return;
    }

    var id = pQueue[pIndex];
    var qc = questionCard(id, {
      mode: 'practice',
      label: 'Question ' + (pIndex + 1) + ' of ' + pQueue.length,
      onAnswer: function (i, ok, after) {
        var prev = S.seen[id] || { n: 0 };
        S.seen[id] = { r: ok ? 1 : 0, n: (prev.n || 0) + 1 };
        save();
        var row = el('div', 'row');
        var nx = el('button', 'btn', pIndex + 1 < pQueue.length ? 'Next question' : 'Finish set');
        nx.onclick = function () { pIndex++; drawPractice(); };
        row.appendChild(nx);
        var back = el('button', 'btn ghost small', 'Change area');
        back.onclick = function () { pArea = null; drawPractice(); };
        row.appendChild(back);
        after.appendChild(row);
        drawTabs();
      }
    });
    vPractice.appendChild(qc.node);

    var skip = el('div', 'row');
    var sk = el('button', 'btn ghost small', 'Skip this one');
    sk.onclick = function () { pIndex++; drawPractice(); };
    skip.appendChild(sk);
    vPractice.appendChild(skip);
  }

  // ---------------------------------------------------------------- tests
  var vTests = document.getElementById('v-tests');
  var run = null; // {key, answers:[], index, submitted}

  function drawTests() {
    vTests.innerHTML = '';
    if (run) return drawRun();
    vTests.appendChild(el('h2', 'f', 'Full length practice tests'));
    vTests.appendChild(el('p', 'lede',
      'No feedback until you submit, the same as the real thing. The real TSIA2 is untimed, ' +
      'so take as long as you need.'));
    var t = el('div', 'tiles');
    TESTS.forEach(function (info) {
      var rec = S.tests[info.id];
      var tile = el('button', 'tile');
      tile.style.setProperty('--band', '#DAB9EE');
      tile.style.setProperty('--sink', '#9257BD');
      tile.innerHTML = '<b>' + info.name + '</b><span>' + info.n + ' questions · ' +
        info.blurb + '</span>' +
        (rec ? '<div class="n">' + rec.right + '/' + rec.total + '</div><span>last score</span>'
             : '<div class="n">✦</div><span>not taken yet</span>');
      tile.onclick = function () {
        run = { key: info.id, answers: new Array(deck(info.id).length).fill(null),
                index: 0, submitted: false, name: info.name };
        drawTests();
      };
      t.appendChild(tile);
    });
    vTests.appendChild(t);
  }

  function drawRun() {
    var items = deck(run.key);
    vTests.innerHTML = '';
    if (run.submitted) return drawReport();

    var head = el('div', 'card');
    head.innerHTML = '<h3>' + run.name + '</h3><div class="stat"><span>' +
      run.answers.filter(function (a) { return a != null; }).length + ' of ' + items.length +
      ' answered</span><span>Question ' + (run.index + 1) + '</span></div>';
    var grid = el('div', 'grid');
    items.forEach(function (_, i) {
      var g = el('button', 'gq', String(i + 1));
      if (run.answers[i] != null) g.setAttribute('data-done', '1');
      if (i === run.index) g.setAttribute('aria-current', 'true');
      g.onclick = function () { run.index = i; drawRun(); };
      grid.appendChild(g);
    });
    head.appendChild(grid);
    vTests.appendChild(head);

    var id = qid(run.key, run.index);
    var qc = questionCard(id, {
      mode: 'test',
      label: 'Question ' + (run.index + 1) + ' of ' + items.length,
      answered: run.answers[run.index],
      onAnswer: function (i) {
        run.answers[run.index] = i;
        if (run.index + 1 < items.length) { run.index++; drawRun(); } else { drawRun(); }
      }
    });
    vTests.appendChild(qc.node);

    var row = el('div', 'row');
    var prev = el('button', 'btn ghost small', 'Back');
    prev.disabled = run.index === 0;
    prev.onclick = function () { run.index--; drawRun(); };
    var next = el('button', 'btn ghost small', 'Next');
    next.disabled = run.index === items.length - 1;
    next.onclick = function () { run.index++; drawRun(); };
    var sub = el('button', 'btn', 'Submit test');
    sub.onclick = function () {
      var blank = run.answers.filter(function (a) { return a == null; }).length;
      if (blank && !window.confirm(blank + ' question' + (blank > 1 ? 's are' : ' is') +
          ' still blank. A blank always counts wrong. Submit anyway?')) return;
      submit();
    };
    var quit = el('button', 'btn ghost small', 'Leave test');
    quit.onclick = function () {
      if (window.confirm('Leave this test? Your answers will not be saved.')) {
        run = null; drawTests();
      }
    };
    row.appendChild(prev); row.appendChild(next); row.appendChild(sub); row.appendChild(quit);
    vTests.appendChild(row);
  }

  function submit() {
    var items = deck(run.key);
    var right = 0;
    var byArea = {};
    AREAS.forEach(function (a) { byArea[a] = { r: 0, t: 0 }; });
    items.forEach(function (q, i) {
      var ok = run.answers[i] === q.ans;
      if (ok) right++;
      byArea[q.area].t++;
      if (ok) byArea[q.area].r++;
      var id = qid(run.key, i);
      var prev = S.seen[id] || { n: 0 };
      S.seen[id] = { r: ok ? 1 : 0, n: (prev.n || 0) + 1 };
    });
    S.tests[run.key] = { right: right, total: items.length, byArea: byArea,
                         when: new Date().toISOString().slice(0, 10) };
    save();
    run.submitted = true;
    run.right = right;
    run.byArea = byArea;
    drawRun();
    drawTabs();
  }

  function readiness(right, total) {
    var p = right / total;
    if (p >= 0.8) return ['Looking college ready', 'That rate is in the range students who score ' +
      '950 or higher usually sit in. Keep the streak going and take the other test.'];
    if (p >= 0.65) return ['Close', 'You are near the line. Work the fix list, then retake this ' +
      'test in a few days.'];
    if (p >= 0.45) return ['Keep building', 'Read the reference sheet for your two weakest areas, ' +
      'work those practice sets, then come back.'];
    return ['Start with the lessons', 'Work the lessons and practice sets one area at a time ' +
      'before taking another full test.'];
  }

  function drawReport() {
    var items = deck(run.key);
    vTests.innerHTML = '';
    var rep = el('div', 'card report');
    rep.innerHTML = '<h2>' + run.name + ' results</h2>' +
      '<div class="verd"><b>' + run.right + ' right out of ' + items.length + '  (' +
      pct(run.right, items.length) + '%)</b></div>';
    var rd = readiness(run.right, items.length);
    var v = el('div', 'verd');
    v.innerHTML = '<b>' + rd[0] + '</b>' + rd[1];
    rep.appendChild(v);
    rep.appendChild(el('h3', 'f', 'How each area went'));
    AREAS.forEach(function (a) {
      var d = run.byArea[a];
      var r = el('div', 'barrow');
      r.innerHTML = '<span class="nm">' + D.meta[a].short + '</span>' +
        '<span class="bar"><i style="width:' + pct(d.r, d.t) + '%;background:' +
        D.meta[a].ink + '"></i></span><span class="vv">' + d.r + '/' + d.t + '</span>';
      rep.appendChild(r);
    });
    var row = el('div', 'row');
    var again = el('button', 'btn', 'Back to tests');
    again.onclick = function () { run = null; drawTests(); };
    var fix = el('button', 'btn ghost small', 'Work my fix list');
    fix.onclick = function () { run = null; go('fix'); };
    row.appendChild(again); row.appendChild(fix);
    rep.appendChild(row);
    vTests.appendChild(rep);

    vTests.appendChild(el('h3', 'f', 'Every question, worked out'));
    items.forEach(function (q, i) {
      var qc = questionCard(qid(run.key, i), {
        mode: 'test', answered: run.answers[i], showSteps: true,
        label: 'Question ' + (i + 1)
      });
      vTests.appendChild(qc.node);
    });
  }

  // ---------------------------------------------------------------- fix list
  var vFix = document.getElementById('v-fix');
  var fQueue = [], fIndex = 0;

  function drawFix() {
    vFix.innerHTML = '';
    vFix.appendChild(el('h2', 'f', 'Your fix list'));
    vFix.appendChild(el('p', 'lede',
      'Every question you have missed sits here until you get it right. ' +
      'Redoing a missed question is worth more than doing a new one.'));
    var ids = fixIds();
    if (!ids.length) {
      vFix.appendChild(el('div', 'empty',
        'Nothing here yet. Miss a question in practice or on a test and it shows up.'));
      return;
    }
    if (!fQueue.length || fIndex >= fQueue.length ||
        fQueue.filter(function (x) { return ids.indexOf(x) >= 0; }).length === 0) {
      fQueue = ids.slice(); fIndex = 0;
    }
    var counts = el('div', 'chips');
    AREAS.forEach(function (a) {
      var n = ids.filter(function (id) { return areaOf(id) === a; }).length;
      var c = tint(el('span', 'chip'), a);
      c.innerHTML = '<i style="background:' + D.meta[a].band + '"></i>' + D.meta[a].short +
        ' <small>' + n + '</small>';
      counts.appendChild(c);
    });
    vFix.appendChild(counts);

    while (fIndex < fQueue.length && ids.indexOf(fQueue[fIndex]) < 0) fIndex++;
    if (fIndex >= fQueue.length) {
      fQueue = ids.slice(); fIndex = 0;
    }
    var id = fQueue[fIndex];
    var qc = questionCard(id, {
      mode: 'practice',
      label: 'Fix ' + (fIndex + 1) + ' of ' + fQueue.length,
      onAnswer: function (i, ok, after) {
        var prev = S.seen[id] || { n: 0 };
        S.seen[id] = { r: ok ? 1 : 0, n: (prev.n || 0) + 1 };
        save();
        var row = el('div', 'row');
        var nx = el('button', 'btn', 'Next');
        nx.onclick = function () { fIndex++; drawFix(); };
        row.appendChild(nx);
        after.appendChild(row);
        drawTabs();
      }
    });
    vFix.appendChild(qc.node);
  }

  // ---------------------------------------------------------------- study
  var vStudy = document.getElementById('v-study');
  function accordion(title, bodyNode, area, open) {
    var a = tint(el('div', 'acc' + (open ? ' open' : '')), area);
    var b = el('button', null, title + '<span>✦</span>');
    b.onclick = function () { a.classList.toggle('open'); };
    var body = el('div', 'body');
    body.appendChild(bodyNode);
    a.appendChild(b); a.appendChild(body);
    return a;
  }

  function drawStudy() {
    vStudy.innerHTML = '';
    vStudy.appendChild(el('h2', 'f', 'Reference sheets and lessons'));
    vStudy.appendChild(el('p', 'lede',
      'Short rules, one example each. Read the sheet for an area before its practice set.'));

    var facts = el('div', 'card');
    facts.innerHTML = '<h3>The test in one box</h3>';
    var tb = el('table', 'dtab');
    tb.style.width = '100%';
    L.front.forEach(function (r) {
      tb.innerHTML += '<tr><th style="text-align:left">' + r[0] + '</th><td style="text-align:left">'
        + r[1] + '</td></tr>';
    });
    facts.appendChild(tb);
    vStudy.appendChild(facts);

    AREAS.forEach(function (a) {
      var wrapN = el('div');
      wrapN.appendChild(el('h3', 'f', D.meta[a].name));
      var refBody = el('div');
      L.ref[a].forEach(function (blk) {
        var d = el('div', 'lrule');
        d.innerHTML = '<div class="lab">' + blk[0].toUpperCase() + '</div><ul>' +
          blk[1].map(function (x) { return '<li>' + x + '</li>'; }).join('') + '</ul>';
        refBody.appendChild(d);
      });
      wrapN.appendChild(accordion('Reference sheet', refBody, a, false));
      var lesBody = el('div');
      L.les[a].forEach(function (les, i) {
        var d = el('div', 'lrule');
        d.innerHTML = '<div class="lab">' + (i + 1) + '. ' + les.title.toUpperCase() + '</div>' +
          '<ul>' + les.rules.map(function (x) { return '<li>' + x + '</li>'; }).join('') + '</ul>' +
          '<div style="margin-top:6px"><b>Example.</b> ' + les.ex[0] + '</div>' +
          les.ex[1].map(function (s) { return '<div>' + s + '</div>'; }).join('') +
          '<div style="margin-top:6px"><b>Watch out.</b> ' + les.watch + '</div>';
        lesBody.appendChild(d);
      });
      wrapN.appendChild(accordion('Lessons', lesBody, a, false));
      vStudy.appendChild(wrapN);
    });
  }

  // ---------------------------------------------------------------- progress
  var vProg = document.getElementById('v-progress');
  function drawProgress() {
    vProg.innerHTML = '';
    vProg.appendChild(el('h2', 'f', 'Your progress'));
    var ids = Object.keys(S.seen);
    var right = ids.filter(function (id) { return S.seen[id].r; }).length;
    var tiles = el('div', 'tiles');
    function tile(n, lab) {
      var t = el('div', 'tile');
      t.style.setProperty('--band', '#DAB9EE');
      t.style.setProperty('--sink', '#9257BD');
      t.innerHTML = '<div class="n">' + n + '</div><span>' + lab + '</span>';
      return t;
    }
    tiles.appendChild(tile(ids.length, 'questions answered'));
    tiles.appendChild(tile(ids.length ? pct(right, ids.length) + '%' : '\u2726', 'answered right'));
    tiles.appendChild(tile(fixIds().length, 'in your fix list'));
    tiles.appendChild(tile(Object.keys(S.tests).length, 'full tests taken'));
    vProg.appendChild(tiles);

    var card = el('div', 'card');
    card.style.setProperty('--band', '#DAB9EE');
    card.innerHTML = '<h3>Practice sets by area</h3>';
    AREAS.forEach(function (a) {
      var st = areaStats(a);
      var r = el('div', 'barrow');
      r.innerHTML = '<span class="nm">' + D.meta[a].short + '</span>' +
        '<span class="bar"><i style="width:' + pct(st.done, st.total) + '%;background:' +
        D.meta[a].ink + '"></i></span><span class="vv">' + st.done + '/' + st.total + '</span>';
      card.appendChild(r);
    });
    vProg.appendChild(card);

    var tcard = el('div', 'card');
    tcard.style.setProperty('--band', '#DAB9EE');
    tcard.innerHTML = '<h3>Test scores</h3>';
    var any = false;
    TESTS.forEach(function (info) {
      var rec = S.tests[info.id];
      if (!rec) return;
      any = true;
      var r = el('div', 'stat');
      r.innerHTML = '<span>' + info.name + ' · ' + rec.when + '</span><span><b>' +
        rec.right + '/' + rec.total + '</b></span>';
      tcard.appendChild(r);
    });
    if (!any) tcard.appendChild(el('div', 'empty', 'No full tests taken yet.'));
    vProg.appendChild(tcard);

    var row = el('div', 'row');
    var reset = el('button', 'btn ghost small', 'Clear all my progress');
    reset.onclick = function () {
      if (window.confirm('Clear every answer, score and fix list item on this device?')) {
        S = { seen: {}, tests: {}, tone: {} };
        save();
        pArea = null; run = null; fQueue = []; fIndex = 0;
        drawProgress(); drawTabs();
      }
    };
    row.appendChild(reset);
    vProg.appendChild(row);
    vProg.appendChild(el('div', 'empty',
      'Your progress is saved in this browser only. It does not travel to another device.'));
  }

  // ---------------------------------------------------------------- boot
  drawTabs();
  go('practice');
})();

};